// extracted by mini-css-extract-plugin
module.exports = {"videoRwdDiv":"cde5","videoRwd":"_7c2c"};